const OldApp = {
  URL: {
    DASHBOARD: '/dashboard',
    DASHBOARD_FORCE: '/dashboard?forceOldDashboard=true',
    WORKFLOW: '/workflow',
    MY_PROFILE: '/user/myProfile',
    BUSINESS_INTEGRATIONS: {
      FACEBOOK: '/user/businessIntegrations?channel=facebook',
      LINKED_IN: '/user/businessIntegrations?channel=linkedin',
      PINTEREST: '/user/businessIntegrations?channel=pinterest',
    },
    BILLING: '/billing',
    BILLING_PLANS: '/billing/extend',
    MEDIA_LIBRARY: '/Albums/index',
    POSTS: '/posts',
    ENGAGE: '/engage/manage',
    ANALYTICS: '/analytics',
    SETTINGS: {
      PROFILES: '/projects/pages',
      PROFILE_GROUPS: '/presets',
      KONTENT_BASE: '/projects/pages/type:global',
      USERS: '/user/listUsers',
      USER: '/user/list/id:',
      BILLING_DASHBOARD: '/billing',
      COMPANY_SETTINGS: '/dashboard/settings',
    },
    HELP_CENTER: {
      TUTORIALS: 'https://vimeo.com/showcase/9925454',
      RESOURCE_CENTER: 'https://help.kontentino.com/en/',
      BOOK_DEMO: 'https://www.kontentino.com/book-a-demo',
      PRODUCT_ROADMAP: 'https://www.kontentino.com/roadmap',
    },
  },
};

export default OldApp;
